"use strict";
/**
 * AVR8js
 *
 * Copyright (C) 2019, 2020, Uri Shaked
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
var cpu_1 = require("./cpu/cpu");
Object.defineProperty(exports, "CPU", { enumerable: true, get: function () { return cpu_1.CPU; } });
var instruction_1 = require("./cpu/instruction");
Object.defineProperty(exports, "avrInstruction", { enumerable: true, get: function () { return instruction_1.avrInstruction; } });
var interrupt_1 = require("./cpu/interrupt");
Object.defineProperty(exports, "avrInterrupt", { enumerable: true, get: function () { return interrupt_1.avrInterrupt; } });
var timer_1 = require("./peripherals/timer");
Object.defineProperty(exports, "AVRTimer", { enumerable: true, get: function () { return timer_1.AVRTimer; } });
Object.defineProperty(exports, "timer0Config", { enumerable: true, get: function () { return timer_1.timer0Config; } });
Object.defineProperty(exports, "timer1Config", { enumerable: true, get: function () { return timer_1.timer1Config; } });
Object.defineProperty(exports, "timer2Config", { enumerable: true, get: function () { return timer_1.timer2Config; } });
var gpio_1 = require("./peripherals/gpio");
Object.defineProperty(exports, "AVRIOPort", { enumerable: true, get: function () { return gpio_1.AVRIOPort; } });
Object.defineProperty(exports, "portAConfig", { enumerable: true, get: function () { return gpio_1.portAConfig; } });
Object.defineProperty(exports, "portBConfig", { enumerable: true, get: function () { return gpio_1.portBConfig; } });
Object.defineProperty(exports, "portCConfig", { enumerable: true, get: function () { return gpio_1.portCConfig; } });
Object.defineProperty(exports, "portDConfig", { enumerable: true, get: function () { return gpio_1.portDConfig; } });
Object.defineProperty(exports, "portEConfig", { enumerable: true, get: function () { return gpio_1.portEConfig; } });
Object.defineProperty(exports, "portFConfig", { enumerable: true, get: function () { return gpio_1.portFConfig; } });
Object.defineProperty(exports, "portGConfig", { enumerable: true, get: function () { return gpio_1.portGConfig; } });
Object.defineProperty(exports, "portHConfig", { enumerable: true, get: function () { return gpio_1.portHConfig; } });
Object.defineProperty(exports, "portJConfig", { enumerable: true, get: function () { return gpio_1.portJConfig; } });
Object.defineProperty(exports, "portKConfig", { enumerable: true, get: function () { return gpio_1.portKConfig; } });
Object.defineProperty(exports, "portLConfig", { enumerable: true, get: function () { return gpio_1.portLConfig; } });
Object.defineProperty(exports, "PinState", { enumerable: true, get: function () { return gpio_1.PinState; } });
var usart_1 = require("./peripherals/usart");
Object.defineProperty(exports, "AVRUSART", { enumerable: true, get: function () { return usart_1.AVRUSART; } });
Object.defineProperty(exports, "usart0Config", { enumerable: true, get: function () { return usart_1.usart0Config; } });
var eeprom_1 = require("./peripherals/eeprom");
Object.defineProperty(exports, "AVREEPROM", { enumerable: true, get: function () { return eeprom_1.AVREEPROM; } });
Object.defineProperty(exports, "EEPROMMemoryBackend", { enumerable: true, get: function () { return eeprom_1.EEPROMMemoryBackend; } });
Object.defineProperty(exports, "eepromConfig", { enumerable: true, get: function () { return eeprom_1.eepromConfig; } });
__exportStar(require("./peripherals/twi"), exports);
var spi_1 = require("./peripherals/spi");
Object.defineProperty(exports, "spiConfig", { enumerable: true, get: function () { return spi_1.spiConfig; } });
Object.defineProperty(exports, "AVRSPI", { enumerable: true, get: function () { return spi_1.AVRSPI; } });
var clock_1 = require("./peripherals/clock");
Object.defineProperty(exports, "AVRClock", { enumerable: true, get: function () { return clock_1.AVRClock; } });
Object.defineProperty(exports, "clockConfig", { enumerable: true, get: function () { return clock_1.clockConfig; } });
